import config from "config";
import { APICore } from "helpers/api/apiCore";
import { FilterMetadata } from "redux/types";
import { ProgrammeAndCounterparyBasedBuyerSellerType, updateBuyerSellerVersion } from "./types";
const api = new APICore();

function mapBuyerSellerTransactionChargeFields(params: any) {
  if (params.chargePayer?.value === "CounterParty") {
    if (!params.transactionChargesApplicable) {
      return {
        transactionChargesApplicable: false,
        transactionChargesBasedOn: null,
        transactionChargeValue: null,
        transactionChargeGst: null
      }
    }
    return {
      transactionChargesApplicable: params.transactionChargesApplicable,
      transactionChargesBasedOn: params.transactionChargesBasedOn?.value ?? params.transactionChargesBasedOn ?? null,
      transactionChargeValue:
        params.transactionChargeValue != null && params.transactionChargeValue !== "" ? params.transactionChargeValue : null,
      transactionChargeGst: params.transactionChargeGst != null && params.transactionChargeGst !== "" ? params.transactionChargeGst : null
    }
  }
  return {
    transactionChargesApplicable: null,
    transactionChargesBasedOn: null,
    transactionChargeValue: null,
    transactionChargeGst: null
  };
}

function fetchBuyerSellersApi(params: FilterMetadata) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customer-relations`;
  return api.get(`${baseUrl}`, params);
}
function fetchBuyerSellerApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customer-relations/${params}`;
  return api.get(`${baseUrl}`, {});
}
function validateBuyerSellerApi(params: any) {
}
function createBuyerSellerApi(params: any) {

  let backendApiUrl = "";
  let apiData: any = {
    branchId: params.branchId.length ? params.branchId[0]["id"] : null,
    coLenderId: params?.colenderId?.length ? params?.colenderId[0]["id"] : null,
    coLenderExternalId: params?.colenderId?.length ? params?.colenderId[0]["externalId"] : null,
    solId : params.solId? params.solId: null,
    coLenderSystemIdentifier: params.coLenderSystemIdentifier ? params.coLenderSystemIdentifier: null,
    coLenderLoanAccountNumber: params.coLenderLoanAccountNumber ? params.coLenderLoanAccountNumber : null,
    programmeId: params.programmeId.length ? params.programmeId[0]["id"] : null,
    counterPartyId: params.customerId.length ? params.customerId[0]["id"] : null,
    invoiceConcentrationAmount: params.invoiceConcentrationAmount ? params.invoiceConcentrationAmount : 0,
    instrumentDueDateCalculation: params.instrumentDueDateCalculation ? params.instrumentDueDateCalculation.value : "None",
    dueDateStrategy: params.dueDateStrategy,
    normalBaseRateId: params.normalBaseRateId?.id,
    // normalSpreadRateOfInterest: params.normalSpreadRateOfInterest ? params.normalSpreadRateOfInterest : 0,
    adhocBaseRateId: params.adhocBaseRateId?.id || null,
    // adhocSpreadRateOfInterest: params?.adhocSpreadRateOfInterest || null,
    // overdueSpreadRateOfInterest: params.overdueSpreadRateOfInterest ? params.overdueSpreadRateOfInterest : 0,
    interestType: params.interestType,
    consolidationType: "Monthly",
    graceDays: params.graceDays ? params.graceDays : 0,
    staleDays: params.staleDays ? params.staleDays : 0,
    autoFinance: params.autoFinance?.value === "yes" ? true : false,
    stopAutoRepayment: params.stopAutoRepayment,
    graceRateOfInterest: params.graceRateOfInterest ? params.graceRateOfInterest : 0,
    validateCreditAccount: params.validateCreditAccount?.value === "yes" ? true : false,
    autoDebit: params.autoDebit ? true : false,
    autoDebitMode: params.autoDebit ? params.autoDebitMode?.value ?? params.autoDebitMode ?? null : null,
    autoDebitBankAccountNumber: params.autoDebitBankAccountNumber ? params.autoDebitBankAccountNumber : "",
    umrnNumber: params?.umrnNumber ? params?.umrnNumber : "",
    interestDebitParty: params.interestDebitParty || "None",
    principalRepaymentBy: params.principalRepaymentBy || "None",
    overdueDebitParty: params.overdueDebitParty || "None",
    borrowerLimitId: params.borrowerLimit?.id ? params.borrowerLimit?.id : null,
    additionalDetails: params.additionalDetails ? params.additionalDetails.trim() : "",
    remarks: params.remarks ? params.remarks.trim() : "",
    excessAdvanceInterestRefundAccountNumber: params.excessAdvanceInterestRefundAccountNumber ? params.excessAdvanceInterestRefundAccountNumber : "",
    excessAdvanceInterestRefundIfscCode: params.excessAdvanceInterestRefundIfscCode ? params.excessAdvanceInterestRefundIfscCode : "",
    repaymentBankAccountNumber: params?.repaymentBankAccountNumber ? params.repaymentBankAccountNumber.trim() : "",

    tenorDays: params.tenorDays ? params.tenorDays : 0,
    isInheritedInvoiceConcentrationAmount: params.isInheritedInvoiceConcentrationAmount ? params.isInheritedInvoiceConcentrationAmount : false,

    isInheritedStaleDays: params.isInheritedStaleDays ? params.isInheritedStaleDays : false,
    isInheritedTenorDays: params.isInheritedTenorDays ? params.isInheritedTenorDays : false,

    isInheritedDailyTransactionLimit: params.isInheritedDailyTransactionLimit ? params.isInheritedDailyTransactionLimit : false,
    dailyTransactionLimit: params?.dailyTransactionLimit,

    isInheritedPaymentBatchingStrategy: true,
    paymentBatchingStrategy: params.paymentBatchingStrategy ? params.paymentBatchingStrategy?.value : "NoBatching",
    maxFinancingPercentage: params.maxFinancingPercentage ? params.maxFinancingPercentage : "0",

    normalDeferredInterestReset: params.normalDeferredInterestReset ? params.normalDeferredInterestReset : false,
    normalApplicableFromDate: params.normalApplicableFromDate ? params.normalApplicableFromDate : null,
    normalNextResetDate: params.normalNextResetDate ? params.normalNextResetDate : null,
    normalPreviousResetDate: null,

    adhocDeferredInterestReset: params.adhocDeferredInterestReset ? params.adhocDeferredInterestReset : false,
    adhocApplicableFromDate: params.adhocApplicableFromDate ? params.adhocApplicableFromDate : null,
    adhocNextResetDate: params.adhocNextResetDate ? params.adhocNextResetDate : null,
    adhocPreviousResetDate: null,

    isInheritedDueDateStrategy: params.isInheritedDueDateStrategy ? params.isInheritedDueDateStrategy : false,
    isInheritedInterestType: params.isInheritedInterestType ? params.isInheritedInterestType : false,
    isInheritedGraceDays: params.isInheritedGraceDays ? params.isInheritedGraceDays : false,
    isInheritedGraceRateOfInterest: params.isInheritedGraceRateOfInterest ? params.isInheritedGraceRateOfInterest : false,
    isInheritedInterestDebitParty: params.isInheritedInterestDebitParty ? params.isInheritedInterestDebitParty : false,
    isInheritedOverdueDebitParty: params.isInheritedOverdueDebitParty ? params.isInheritedOverdueDebitParty : false,
    isInheritedPrincipalRepaymentBy: params.isInheritedPrincipalRepaymentBy ? params.isInheritedPrincipalRepaymentBy : false,
    isInheritedMaxFinancingPercentage: params.isInheritedMaxFinancingPercentage ? params.isInheritedMaxFinancingPercentage : false,
    isInheritedNormalBaseRateId: params.isInheritedNormalBaseRateId ? params.isInheritedNormalBaseRateId : false,
    isInheritedAdhocBaseRateId: params.isInheritedAdhocBaseRateId ? params.isInheritedAdhocBaseRateId : false,
    isSeperateAccountForAdvanceInterest: params.isSeperateAccountForAdvanceInterest,
    partialDisbursementAllowed: params.partialDisbursementAllowed,
    isInheritedPartialDisbursementAllowed: params.isInheritedPartialDisbursementAllowed ? params.isInheritedPartialDisbursementAllowed : false,

    isMarginRefundApplicable: params.isMarginRefundApplicable ? params.isMarginRefundApplicable.value : false,

    marginAmountAccountNumber: params?.marginAmountAccountNumber,
    marginAmountIfscCode: params?.marginAmountIfscCode,
    loanAccountNumber: params?.relationshipAccountNumber ? params?.relationshipAccountNumber : null,
    isAutoGeneratedLoanAccountNumber: params?.isAutoGeneratedLoanAccountNumber,
    subLimitAmount: params?.subLimitAmount ? params?.subLimitAmount : 0,
    roiSlabs: params.roiSlabs || null,
    isInheritedNormalRoiSlabs: params.isInheritedNormalRoiSlabs || false,
    isInheritedAdhocRoiSlabs: params.isInheritedAdhocRoiSlabs || false,
    isInheritedOverdueRoiSlabs: params.isInheritedOverdueRoiSlabs || false,
    isInheritedAutoFinance: params.isInheritedAutoFinance ? params.isInheritedAutoFinance : false,
    ...mapBuyerSellerTransactionChargeFields(params)
  };
  if (!params.draft) {
    apiData.makerRemarks = params.makerRemarks ? params.makerRemarks.trim() : "";
    backendApiUrl = `${config.BACKEND_BASE_URL}/customer-relations`;
  } else {
    backendApiUrl = `${config.BACKEND_BASE_URL}/customer-relations?draft=${params.draft}&group=${params.group}`;
  }
  const baseUrl = backendApiUrl;
  return api.create(`${baseUrl}`, apiData);
}
function fetchBuyerSellerVersionApi(params: any) {
  let filterdata = {
    pgno: params.pgno,
    pgsz: params.pgsz,
    sort: params.sort
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/customer-relations/${params.id}/versions`;
  return api.get(`${baseUrl}`, filterdata);
}



function deleteBuyerSellerApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customer-relations/${params}`;
  return api.delete(`${baseUrl}`);
}


function fetchBuyerSellerLatestVersionApi(params: any) {
  let flag = {
    modifyLatest: params?.status === "New" ? false : true
  }
  const baseUrl = `${config.BACKEND_BASE_URL}/customer-relations/${params?.externalId}/latestVersion`;
  return api.get(`${baseUrl}`, flag);
}

function approveBuyerSellerpi(params: updateBuyerSellerVersion) {
  let remarks = {
    checkerRemarks: params.checkerRemarks.trim()
  };
  let externalBaseRateId = params.externalCustomerId;
  const baseUrl = `${config.BACKEND_BASE_URL}/customer-relations/${externalBaseRateId}/approve`;
  return api.updatePatch(`${baseUrl}`, remarks);
}
function rejectBuyerSellerpi(params: updateBuyerSellerVersion) {
  let remarks = {
    checkerRemarks: params.checkerRemarks.trim()
  };
  let externalBaseRateId = params.externalCustomerId;
  const baseUrl = `${config.BACKEND_BASE_URL}/customer-relations/${externalBaseRateId}/reject`;
  return api.updatePatch(`${baseUrl}`, remarks);
}
function sentBackBuyerSellerApi(params: updateBuyerSellerVersion) {
  let remarks = {
    checkerRemarks: params.checkerRemarks.trim()
  };
  let externalBaseRateId = params.externalCustomerId;
  const baseUrl = `${config.BACKEND_BASE_URL}/customer-relations/${externalBaseRateId}/sent-back`;
  return api.updatePatch(`${baseUrl}`, remarks);
}
function buyerSellerBlockApi(params: any) {
  const param = {
    inactiveReason: params.inactiveReason.trim()
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/customer-relations/${params.id}/block`;
  return api.updatePatch(`${baseUrl}`, param);
}
function updateBuyerSellerApi(params: any) {
  let backendApiUrl = "";
  let apiData: any = {
    branchId: params?.branchId?.length ? params.branchId[0]["id"] : null,
    coLenderId: params?.colenderId?.length ? params?.colenderId[0]["id"] : null,
    coLenderExternalId: params?.colenderId?.length ? params?.colenderId[0]["externalId"] : null,
    solId: params.solId ? params.solId : null,
    coLenderSystemIdentifier: params.coLenderSystemIdentifier ? params.coLenderSystemIdentifier: null,
    coLenderLoanAccountNumber: params.coLenderLoanAccountNumber ? params.coLenderLoanAccountNumber : null,
    programmeId: params.programmeId.length ? params.programmeId[0]["id"] : null,
    counterPartyId: params.customerId.length ? params.customerId[0]["id"] : null,
    invoiceConcentrationAmount: params.invoiceConcentrationAmount ? params.invoiceConcentrationAmount : 0,
    dailyTransactionLimit: params.dailyTransactionLimit,
    instrumentDueDateCalculation: params.instrumentDueDateCalculation?.value ? params?.instrumentDueDateCalculation?.value : null,
    dueDateStrategy: params.dueDateStrategy,
    normalBaseRateId: params.normalBaseRateId?.id,
    // normalSpreadRateOfInterest: params?.normalSpreadRateOfInterest ? params?.normalSpreadRateOfInterest : 0,
    adhocBaseRateId: params.adhocBaseRateId?.id || null,
    // adhocSpreadRateOfInterest: params?.adhocSpreadRateOfInterest || null,
    // overdueSpreadRateOfInterest: params?.overdueSpreadRateOfInterest ? params?.overdueSpreadRateOfInterest : 0,
    interestType: params?.interestType,
    consolidationType: "Monthly",
    graceDays: params?.graceDays ? params?.graceDays : 0,
    tenorDays: params.tenorDays ? params.tenorDays : 0,
    staleDays: params?.staleDays ? params?.staleDays : 0,
    autoFinance: params?.autoFinance ?? false,
    stopAutoRepayment: params?.stopAutoRepayment ?? false,
    isSeperateAccountForAdvanceInterest: params.isSeperateAccountForAdvanceInterest,
    advanceInterestDebitAccountNumber: params.advanceInterestDebitAccountNumber ? params.advanceInterestDebitAccountNumber : "",
    graceRateOfInterest: params?.graceRateOfInterest ? params?.graceRateOfInterest : 0,
    validateCreditAccount: params?.validateCreditAccount ?? false,
    autoDebit: params.autoDebit ? true : false,
    autoDebitMode: params.autoDebit ? params.autoDebitMode?.value ?? params.autoDebitMode ?? null : null,
    autoDebitBankAccountNumber: params?.autoDebitBankAccountNumber ? params?.autoDebitBankAccountNumber : "",
    umrnNumber: params?.umrnNumber ? params?.umrnNumber : "",
    interestDebitParty: params?.interestDebitParty || "None",
    overdueDebitParty: params?.overdueDebitParty || "None",
    principalRepaymentBy: params?.principalRepaymentBy || "None",
    borrowerLimitId: params?.borrowerLimit?.id ? params?.borrowerLimit?.id : null,
    additionalDetails: params?.additionalDetails ? params?.additionalDetails.trim() : "",
    remarks: params?.remarks ? params?.remarks.trim() : "",
    excessAdvanceInterestRefundAccountNumber:
      params.excessAdvanceInterestRefundAccountNumber ?
        params.excessAdvanceInterestRefundAccountNumber : "",
    excessAdvanceInterestRefundIfscCode: params.excessAdvanceInterestRefundIfscCode ? params.excessAdvanceInterestRefundIfscCode : "",
    repaymentBankAccountNumber: params?.repaymentBankAccountNumber ? params.repaymentBankAccountNumber.trim() : "",
    paymentBatchingStrategy: params.paymentBatchingStrategy ? params.paymentBatchingStrategy?.value : "NoBatching",
    maxFinancingPercentage: params.maxFinancingPercentage ? params.maxFinancingPercentage : "0",

    isInheritedInvoiceConcentrationAmount: params.isInheritedInvoiceConcentrationAmount ? params.isInheritedInvoiceConcentrationAmount : false,
    isInheritedStaleDays: params.isInheritedStaleDays ? params.isInheritedStaleDays : false,
    isInheritedTenorDays: params.isInheritedTenorDays ? params.isInheritedTenorDays : false,
    isInheritedDailyTransactionLimit: params.isInheritedDailyTransactionLimit ? params.isInheritedDailyTransactionLimit : false,
    isInheritedPaymentBatchingStrategy: params.isInheritedPaymentBatchingStrategy ? params.isInheritedPaymentBatchingStrategy : false,
    isInheritedDueDateStrategy: params.isInheritedDueDateStrategy ? params.isInheritedDueDateStrategy : false,
    isInheritedInterestType: params.isInheritedInterestType ? params.isInheritedInterestType : false,
    isInheritedGraceDays: params.isInheritedGraceDays ? params.isInheritedGraceDays : false,
    isInheritedGraceRateOfInterest: params.isInheritedGraceRateOfInterest ? params.isInheritedGraceRateOfInterest : false,
    isInheritedInterestDebitParty: params.isInheritedInterestDebitParty ? params.isInheritedInterestDebitParty : false,
    isInheritedOverdueDebitParty: params.isInheritedOverdueDebitParty ? params.isInheritedOverdueDebitParty : false,
    isInheritedPrincipalRepaymentBy: params.isInheritedPrincipalRepaymentBy ? params.isInheritedPrincipalRepaymentBy : false,
    isInheritedMaxFinancingPercentage: params.isInheritedMaxFinancingPercentage ? params.isInheritedMaxFinancingPercentage : false,
    isInheritedNormalBaseRateId: params.isInheritedNormalBaseRateId ? params.isInheritedNormalBaseRateId : false,
    isInheritedAdhocBaseRateId: params.isInheritedAdhocBaseRateId ? params.isInheritedAdhocBaseRateId : false,

    normalDeferredInterestReset: params.normalDeferredInterestReset ? params.normalDeferredInterestReset : false,
    normalApplicableFromDate: params.normalApplicableFromDate ? params.normalApplicableFromDate : null,
    normalNextResetDate: params.normalNextResetDate ? params.normalNextResetDate : null,
    normalPreviousResetDate: params.normalPreviousResetDate ? params.normalPreviousResetDate : null,

    adhocDeferredInterestReset: params.adhocDeferredInterestReset ? params.adhocDeferredInterestReset : false,
    adhocApplicableFromDate: params.adhocApplicableFromDate ? params.adhocApplicableFromDate : null,
    adhocNextResetDate: params.adhocNextResetDate ? params.adhocNextResetDate : null,
    adhocPreviousResetDate: params.adhocPreviousResetDate ? params.adhocPreviousResetDate : null,
    isMarginRefundApplicable: params.isMarginRefundApplicable ? params.isMarginRefundApplicable.value : false,

    marginAmountAccountNumber: params?.marginAmountAccountNumber,
    marginAmountIfscCode: params?.marginAmountIfscCode,
    loanAccountNumber: params?.relationshipAccountNumber ? params?.relationshipAccountNumber : params?.loanAccountNumber ? params?.loanAccountNumber : "",
    isAutoGeneratedLoanAccountNumber: params?.isAutoGeneratedLoanAccountNumber,
    partialDisbursementAllowed: params.partialDisbursementAllowed,
    isInheritedPartialDisbursementAllowed: params.isInheritedPartialDisbursementAllowed ? params.isInheritedPartialDisbursementAllowed : false,
    subLimitAmount: params?.subLimitAmount ? params.subLimitAmount : 0,
    roiSlabs: params.roiSlabs || null,
    isInheritedNormalRoiSlabs: params.isInheritedNormalRoiSlabs || false,
    isInheritedAdhocRoiSlabs: params.isInheritedAdhocRoiSlabs || false,
    isInheritedOverdueRoiSlabs: params.isInheritedOverdueRoiSlabs || false,
    isInheritedAutoFinance: params.isInheritedAutoFinance ? params.isInheritedAutoFinance : false,
    ...mapBuyerSellerTransactionChargeFields(params)
  };
  if (!params.draft) {
    apiData.makerRemarks = params.makerRemarks ? params.makerRemarks.trim() : "";
    backendApiUrl = `${config.BACKEND_BASE_URL}/customer-relations/${params.externalId}`;
  } else {
    backendApiUrl = `${config.BACKEND_BASE_URL}/customer-relations/${params.externalId}?draft=${params.draft}&group=${params.group}`;
  }
  const baseUrl = backendApiUrl;
  return api.update(`${baseUrl}`, apiData);
}

function buyerSellerFreezeApi(params: any) {
  const param = {
    inactiveReason: params.inactiveReason.trim()
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/customer-relations/${params.id}/freeze`;
  return api.updatePatch(`${baseUrl}`, param);
}

function buyerSellerUnFreezeApi(params: any) {
  const param = {
    inactiveReason: params.inactiveReason.trim()
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/customer-relations/${params.id}/unfreeze`;
  return api.updatePatch(`${baseUrl}`, param);
}

function fetchBuyerSellerpartialDisbursementAllowedApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customer-relations/${params}/partialDisbursementAllowed`;
  return api.get(`${baseUrl}`, {});
}

function fetchBuyerSellerVerionDetailsApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customer-relations/${params?.externalID}/versions/${params?.internalID}`;
  return api.get(`${baseUrl}`, {});
}

function createRelationAccountNumberApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customer-relations/${params}/autogenerate-loan-account-number`;
  return api.get(`${baseUrl}`, {});
}

function fetchBuyerSellerConfigValueApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/financing-programs/${params?.id}/config`;
  return api.create(`${baseUrl}`, params.value);
}

function fetchProgrammeAndCounterparyBasedBuyerSellerApi(params: ProgrammeAndCounterparyBasedBuyerSellerType) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customer-relations/${params.counterPartyId}/${params.programmeId}/customer-relationship-by-programme-and-counterparty-id`;
  return api.get(`${baseUrl}`, {});
}

export {
  fetchBuyerSellersApi,
  fetchBuyerSellerApi,
  fetchBuyerSellerVersionApi,
  validateBuyerSellerApi,
  createBuyerSellerApi,
  approveBuyerSellerpi,
  rejectBuyerSellerpi,
  sentBackBuyerSellerApi,
  buyerSellerBlockApi,
  updateBuyerSellerApi,
  buyerSellerFreezeApi,
  buyerSellerUnFreezeApi,
  fetchBuyerSellerpartialDisbursementAllowedApi,
  fetchBuyerSellerConfigValueApi,
  createRelationAccountNumberApi,
  fetchBuyerSellerVerionDetailsApi,
  fetchBuyerSellerLatestVersionApi,
  deleteBuyerSellerApi,
  fetchProgrammeAndCounterparyBasedBuyerSellerApi
};
